import * as React from "react";
import { Body1, Caption1, Card, Divider, makeStyles, tokens } from "@fluentui/react-components";
import { Mail24Regular } from "@fluentui/react-icons";

import { useMailboxItem } from "./MailboxContext";

import { brandSoftBackground } from "@shared/config/theme";

const useStyles = makeStyles({
  card: {
    margin: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL} 0`,
    padding: tokens.spacingVerticalM,
    backgroundColor: brandSoftBackground,
    rowGap: tokens.spacingVerticalS,
  },
  row: {
    display: "flex",
    gap: tokens.spacingHorizontalS,
    alignItems: "center",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorBrandForeground1,
    flexShrink: 0,
  },
  text: {
    minWidth: 0,
    flexGrow: 1,
  },
  subject: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  meta: {
    display: "block",
    color: tokens.colorNeutralForeground3,
  },
  hint: {
    display: "block",
    color: tokens.colorNeutralForeground3,
  },
});

const ItemContextCard: React.FC = () => {
  const styles = useStyles();
  const { subject, senderName, attachments } = useMailboxItem();

  const isWebHost = Office.context.platform === Office.PlatformType.OfficeOnline;

  return (
    <Card className={styles.card} appearance="filled-alternative">
      <div className={styles.row}>
        <div className={styles.iconBox}>
          <Mail24Regular />
        </div>
        <div className={styles.text}>
          <Body1 className={styles.subject}>{subject || "(no subject)"}</Body1>
          <Caption1 className={styles.meta}>
            {senderName ? `From ${senderName}` : "Unknown sender"} · {attachments.length}{" "}
            {attachments.length === 1 ? "attachment" : "attachments"}
          </Caption1>
        </div>
      </div>
      {isWebHost && (
        <>
          <Divider />
          <Caption1 className={styles.hint}>
            Switched to a different email? Outlook doesn&apos;t always refresh this pane on its own here — close it
            and reopen it from the ribbon to see the new message.
          </Caption1>
        </>
      )}
    </Card>
  );
};

export default ItemContextCard;
